import PriceFormatter from 'features/shared/components/formatters/PriceFormatter';
import { Currency } from 'features/shared/enums/currency';
import React from 'react';
import InvoiceRecapitulationDTO from '../dtos/InvoiceRecapitulationDTO';
import { InvoiceRecapitulationType } from '../enums/invoiceRecapitulationType';
import { useTranslation } from 'react-i18next';
interface Props {
  invoiceRecapitulation: InvoiceRecapitulationDTO[];
  recapitulationType: InvoiceRecapitulationType;
  currency: Currency;
  includeTax: boolean;
}

const InvoiceTotalAmount = ({ invoiceRecapitulation, recapitulationType, currency, includeTax }: Props) => {
  // translations
  const tLabels = useTranslation("invoice\\invoice").t;

  // helpers
  const getAmount = () => {
    let item = invoiceRecapitulation.find(x => x.invoiceRecapitulationType === recapitulationType);

    if (item) {
      if (includeTax) {
        return item?.taxInclusiveAmount ? item.taxInclusiveAmount : 0;
      } else {
        return item?.taxableAmount ? item.taxableAmount : 0;
      }
    }

    return 0;
  }

  // render
  return (
    <div className="d-flex flex-wrap ml-sm-auto pl-sm-3">
      <span className="text-muted mr-2">{tLabels("invoiceTotalAmount.total")}</span>
      <span className="font-weight-bold">
        <PriceFormatter amount={getAmount()} currency={currency}/>
      </span>
    </div>
  )
}

export default InvoiceTotalAmount;
